import type { SVGProps } from 'react';
const SvgGraphBarHorizontal = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Graph Bar Horizontal Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M1.321 3.304h11.443v3.49H1.32z" />
      <path d="M1.321 6.793h8.015v3.49H1.32z" />
      <path d="M1.321 10.282H17.18v3.49H1.32z" />
      <path d="M1.321 1.321V17.18H17.18" />
    </g>
  </svg>
);
export default SvgGraphBarHorizontal;
